import { axios } from '@/utils/request'

// 公告列表
export function getNoticeList(params) {
  return axios({
    url: '/distribution/systemNotice',
    method: 'GET',
    params
  })
}
// 查看公告
export function viewNotice(id) {
  return axios({
    url: '/distribution/systemNotice/' + id,
    method: 'GET'
  })
}
// 登录公告弹窗
export function loginNotice() {
  return axios({
    url: '/distribution/systemNotice/getAlterNotices',
    method: 'GET'
  })
}
// 新手教程弹窗公告
export function getTutorial() {
  return axios({
    url: '/frontend/helpCenterArticle/tutorial',
    method: 'GET'
  })
}
